import { ref } from "vue";

export function useUploadProgress() {
  const progress = ref(0);

  const upload = async (
    url: string,
    file: File,
    onProgress?: (progress: number) => void,
  ) => {
    const xhr = new XMLHttpRequest();
    await new Promise((resolve) => {
      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const currentProgress = (event.loaded / event.total) * 100;
          progress.value = currentProgress;
          onProgress?.(currentProgress);
        }
      });
      xhr.addEventListener("loadend", () => {
        resolve(xhr.readyState === 4 && xhr.status === 200);
      });
      xhr.open("PUT", url, true);
      xhr.setRequestHeader("Content-Type", "application/octet-stream");
      xhr.send(file);
    });
  };

  return { progress, upload };
}
